export default __webpack_public_path__ + "static/media/h_company.d80131e3.png";